<template>
  <div class="space-y-2">
    <p>
      If you have any questions or concerns about this Cookie Policy, please contact us at:
    </p>
    <ul class="list-disc list-inside space-y-1">
      <li>Voxbet</li>
      <li>Email: <a href="mailto:info@betpic.com" class="text-blue-600 dark:text-blue-400 underline">info@betpic.com</a></li>
      <li>Website: <a href="https://betpic.com" target="_blank" rel="noopener noreferrer" class="text-blue-600 dark:text-blue-400 underline">betpic.com</a></li>
    </ul>
  </div>
</template>